import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { DropDownRequest, DropDownResponse, RequirmentTypeModel, WHLocationModel } from '../../Models/DropDwon/DropDownRequest';
import { productModel } from '../../Models/DropDwon/ProductModel';
import { ToastrService } from 'ngx-toastr';
import { SDAcknowledgeService } from '../../Services/SDAcknowledge/sd-acknowledge.service';
import { DatePipe } from '@angular/common';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';
import { monthModel } from 'src/app/Models/DropDwon/MonthModel';

@Component({
    selector: 'sd-acknowledge',
    templateUrl: './sd-acknowledge.component.html',
    styleUrls: ['./sd-acknowledge.component.css']
})
export class SDAcknowledge implements OnInit {
    
    
    public loader: string = "none";
    @ViewChild('productSelect') productSelect;
    @ViewChild('WHLocationItem') WHLocationItem;
    @ViewChild('AddRowWHLocation') AddRowWHLocation;
    @ViewChild('AddRowProduct') AddRowProduct;
    @ViewChild('AddRowPackSize') AddRowPackSize;
    @ViewChild('AddRowRecThrough') AddRowRecThrough;
    @ViewChild('monthSelect') monthSelect;
    @ViewChild('AddRowMonth') AddRowMonth;
    @ViewChild('year') year;
    public YearSettings= {};
    public form: FormGroup;

    public userId: string;
    public roleId: string;
    public FlagDropDown: string;

    public ddlRequest: DropDownRequest = new DropDownRequest();
    public ddlResponse: DropDownResponse = new DropDownResponse();

    public ddlResponseWH: DropDownResponse = new DropDownResponse();

    public RequirmentTypeSettings = {};
    public requirmentTypeDdl: RequirmentTypeModel[];
    public requirmentDllValue: any;

    public WHLocationSettings = {};
    public whLocationDdl: WHLocationModel[];
    public whLocationDDlValue: any;

    public ProductSettings = {};
    public ProductSelectedItem: productModel[];


    public AddRowWHLocationSettings = {};
    public AddRowWHLocationDDlValue: any;

    public AddRowProductSettings = {};
    public AddRowProductSelectedItem: productModel[];

    public AddRowReceivedThroughSettings = {};
    public AddRowPackSizeSettings = {};
    
    public MonthSettings = {};
    public MonthSelectedItem: monthModel[];

    public BusinessUnitSettings = {};
    //public MonthSelectedItem: monthModel[];

    public CostCenterSettings = {};
    //public MonthSelectedItem: monthModel[];

    public AddRowMonthSettings = {};
    public AddRowMonthSelectedItem: monthModel[];

    public AddRowBusinessUnitSettings ={};
    //public AddRowCostCenterSelectedItem: productModel[];

    public AddRowCostCenterSettings ={};
    public isStockAvailable: boolean = true;
    //public AddRowCostCenterSelectedItem: productModel[];

    wareHouseLocation: string;
    selectedReqType: any = [];
    selectedRegion: any = [];
    public files: File[] = [];
    public fileName: string = '';
    defaultView: boolean = true;
    totalRecord: any;
    currentPage: any;
    lastPage: any;
    isDisabledPrevious = true;
    isDisabledNext = false;
    dispatchToSDObj: any = [];
    dispatchToSDWarehouseObj: any=[];
    userName: string;
    recordsOnCurrentPage: number = 10;
    startRecord: number = 1;
    defaultValue = "none";
    dynamicAddRow: any = [];
    newAddRow: any = {};
    productPackSize: any[] = [];
    displayReject = 'none';
    displayEdit = 'none';
    editStockIn: any = {};
    editProductPackSize: any[] = [];
    currentYear = new Date().getFullYear();

    constructor(private ddlServices: DropDownService, private toastr: ToastrService, private sdAcknowledge: SDAcknowledgeService) {
        this.userId = localStorage.getItem('dsu_userId');
        this.roleId = localStorage.getItem('dsu_roleId');
        this.userName = localStorage.getItem('dsu_userName');
        this.FlagDropDown = (this.roleId == "39" || this.roleId == "43" || this.roleId == "44") ? "Supervisor" : "DEFAULT";
    }

    ngOnInit() {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse = response.data;
                    const years=response.data.year;
                    if (years.length >= 2) {
                        // Extract the last two items
                        this.ddlResponse.year = years.slice(-2);
                      } else {
                        // Handle cases where there are fewer than two items
                        this.ddlResponse.year = years;
                      }
                    class YearItemList{
                        id: any;
                        text: any;
                    }
                      let requiredItem: YearItemList[] = [];
                      var obj = {
                        id : this.ddlResponse.year[0].currentrequirementYear,
                        text: this.ddlResponse.year[0].currentrequirementYear
                      }
                      requiredItem.push(obj)
                      this.year.selectedItems=requiredItem;
                    this.YearSetting();  
                }   
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });


        this.WHLocationSetting();
        this.GetWarehouseLocationData(this.userId, this.roleId, "TRUE");
        this.ProductSetting();
        this.MonthSetting();
        //this.BusinessUnitSetting();
        //this.CostCenterSetting();
        this.AddRowWHLocationSetting();
        this.AddRowProductSetting();
        this.AddRowPackSizeSetting();
        this.GetSDAcknowledgeData();
        this.AddRowMonthSetting();
        this.AddRowBusinessUnitSetting();
        this.AddRowCostCenterSetting();
        this.loader = 'none';
    }

    YearSetting(){
        this.YearSettings = {
          singleSelection: true,
          idField: 'year',
          textField: 'year',
          enableCheckAll: false,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: false,
          limitSelection: -1,
          clearSearchFilter: false,
          itemsShowLimit: 1,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Year Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false
        };
    } 
    WHLocationSetting() {
        this.WHLocationSettings = {
            singleSelection: false,
            idField: 'whId',
            textField: 'whName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Location Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    WHLocation() {
        this.whLocationDdl = [{ WHId: "1", WHName: "WHName1" }, { WHId: "2", WHName: "WHName2" }]
    }

    AddRowWHLocationSetting() {
        this.AddRowWHLocationSettings = {
            singleSelection: true,
            idField: 'whCode',
            textField: 'whName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Location Found',
            closeDropDownOnSelection: true,
        };
    }

    AddRowPackSizeSetting() {
        this.AddRowPackSizeSettings = {
            singleSelection: true,
            idField: 'packSize',
            textField: 'packSize',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Pack Size Found',
            closeDropDownOnSelection: true,

        };
    }


    AddRowProductSetting() {
        this.AddRowProductSettings = {
            singleSelection: true,
            idField: 'productCode',
            textField: 'productName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: true,

        };
    }

    AddRowMonthSetting() {
        this.AddRowMonthSettings = {
            singleSelection: true,
            idField: 'monthId',
            textField: 'monthName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Month Found',
            closeDropDownOnSelection: true,

        };
    }

    
    AddRowBusinessUnitSetting() {
        this.AddRowBusinessUnitSettings = {
            singleSelection: true,
            idField: 'code',
            textField: 'name',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No BU Found',
            closeDropDownOnSelection: true,

        };
    }

    AddRowCostCenterSetting() {
        this.AddRowCostCenterSettings = {
            singleSelection: true,
            idField: 'code',
            textField: 'name',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No CC Found',
            closeDropDownOnSelection: true,

        };
    }

    ProductSetting() {
        this.ProductSettings = {
            singleSelection: false,
            idField: 'productId',
            textField: 'productName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    MonthSetting() {
        this.MonthSettings = {
            singleSelection: false,
            idField: 'monthId',
            textField: 'monthName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Month Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    BusinessUnitSetting() {
        this.BusinessUnitSettings = {
            singleSelection: false,
            idField: 'code',
            textField: 'name',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No BU Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    CostCenterSetting() {
        this.CostCenterSettings = {
            singleSelection: false,
            idField: 'code',
            textField: 'name',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No BU Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }


    GetWarehouseLocationData(userId: string, roleId: string, IsOnInit: string) {
        let obj: DropDownRequest = new DropDownRequest();

        this.loader = 'block';
        obj.UserId = this.userId;
        obj.Role = this.roleId;
        obj.Flag = IsOnInit;
        obj.SD = '';
        this.ddlServices.getWarehouseLocationDropDown(obj)
            .subscribe((response) => {
                if (response.status) {

                    this.ddlResponseWH.warehouseLocation = response.data.warehouse;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }


    reset() {
        this.defaultValue = 'none';
        if (this.productSelect != undefined) {
            this.productSelect.selectedItems = [];
        }
        if (this.monthSelect != undefined) {
            this.monthSelect.selectedItems = [];
        }
        
        if (this.WHLocationItem != undefined) {
            this.WHLocationItem.selectedItems = [];
        }
        if (this.year != undefined)
            {
                class YearItemList{
                    id: any;
                    text: any;
                }
                let requiredItem: YearItemList[] = [];
                var obj = {
                  id : this.ddlResponse.year[0].currentrequirementYear,
                  text: this.ddlResponse.year[0].currentrequirementYear
                }
                requiredItem.push(obj)
                this.year.selectedItems=requiredItem;
            }

        this.defaultView = true;
    }



    GetSDAcknowledge() {
        this.isStockAvailable = true;
        let year="";
        let isValid = true;
        this.userId = localStorage.getItem('dsu_userId');
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let month = Array.prototype.map.call(this.monthSelect.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
       
        if (whLocation == "" || whLocation == null) {
            this.toastr.error("Please select Warehouse Location");
            isValid = false;
            return false;
        }
        if (product == "" || product == null) {
            this.toastr.error("Please select Product");
            isValid = false;
            return false;
        }
        if (month == "" || month == null) {
            this.toastr.error("Please select Month");
            isValid = false;
            return false;
        }
        if (year == "" || year == null) {
            this.toastr.error("Please select Year");
            isValid = false;
            return false;
        }
        if (isValid) {
            this.loader = 'block';
            this.sdAcknowledge.GetAcknowledgeFilter(whLocation, product, year,month, this.userId)
                .subscribe((response) => {
                    if (response.status) {
                        this.dynamicAddRow = [];
                        this.defaultView = false;
                        this.dispatchToSDObj = response.data;
                        if(this.dispatchToSDObj.stockAvailable.length <= 0){
                            this.isStockAvailable = false;
                           // this.toastr.error("No data found");
                        }
                        this.AddRowProductSetting();
                        this.AddRowPackSizeSetting();
                        this.AddRowMonthSetting();
                        if (this.dispatchToSDObj.stockAvailable.length > 0) {
                            for(let i=0;i<this.dispatchToSDObj.stockAvailable.length;i++){
                            this.AddRow(i, this.dispatchToSDObj.stockAvailable);
                            }
                        }
                        this.dispatchToSDWarehouseObj = response.data.historyStockAvailable
                      
                    }
                    else {
                       // this.toastr.error(response.message);
                    }
                    this.loader = 'none';
                }, error => {
                    this.loader = 'none';
                });
        }

    }

    GetSDAcknowledgeData(){
        this.userId = localStorage.getItem('dsu_userId');
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let month = Array.prototype.map.call(this.monthSelect.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");
        let year="";
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.sdAcknowledge.GetSDAcknowledge(whLocation, product, month, this.userId ,year)
                .subscribe((response) => {
                    if (response.status) {
                        this.dynamicAddRow = [];
                        this.defaultView = false;
                        this.dispatchToSDWarehouseObj = response.data.historyStockAvailable

                    }
                    else {
                        //this.toastr.error(response.message);
                    }
                    this.loader = 'none';
                }, error => {
                    this.loader = 'none';
                });
        }
    

    AddRowForEdit(index, data) {
        var datePipe = new DatePipe("en-US");
        let mfgDate = data.mfgDate;
        data.mfgDate = datePipe.transform(mfgDate, 'dd/MMM/yyyy');
        let expDate = data.expDate;
        data.expDate = datePipe.transform(expDate, 'dd/MMM/yyyy');
        let invDate = data.invDate;
        data.invDate = datePipe.transform(invDate, 'dd/MMM/yyyy');

        this.newAddRow =
        {
            Id: data.id,
            WarehouseCode: data.warehouseCode,
            WarehouseLocation: data.warehouseLocation,
            ItemCode: data.itemCode,
            ItemName: data.itemName,
            PackSize: data.packSize,
            PackMRP: data.packMRP,
            BatchNo: data.batchNo,
            Qty: data.qty,
            LR: data.lr,
            CarrierDetail: data.CarrierDetail,
            OriginLocation: data.originLocation,
            MFGDate: data.mfgDate,
            EXPDate: data.expDate,
            DocNo: data.docNo,
            InvNo: data.invNo,
            InvDate: data.invDate,
            IsEdit: false,
            RequirementYear: data.requirementYear

        }


        this.productPackSize.push(0);
        this.productPackSize[index] = [];
        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == data.itemCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.productPackSize[index].push(packSize);


            }
        }
        this.dynamicAddRow.push(this.newAddRow);

    }

    AddRow(index,data) {
        var value= data[index].originLocationName.split('(');
        this.newAddRow =
        {
            Id: 0,
            WarehouseCode: data[index].whCode,
            WarehouseLocation: data[index].whName,
            ProductCode: data[index].productCode,
            ProductName: data[index].productName,
            PackSize: data[index].packSize,
            PackMRP: data[index].packMRP,
            BatchNo: data[index].batchNo,
            QtyDispatched: data[index].qtyDispatched,
            LR: data[index].lr,
            OriginLocation: data[index].originLocation,
            OriginLocationName: value[0],
            OriginLocationValue: data[index].originLocationName,
            CarrierDetail: data[index].carrierDetail,
            MFGDate: data[index].mfgDate,
            EXPDate: data[index].expDate,
            InvNo: data[index].invNo,
            InvDate: data[index].invDate,
            BusinessUnit:"",
            CostCenter:"",
            IsAcknowledged:false,
            dispatchId:data[index].id,
            Month:data[index].month,
            IsEdit: true,
            RequirementYear: data[index].requirementYear
        }
        this.productPackSize.push(0);
        this.dynamicAddRow.push(this.newAddRow);
        return true;
    }
	
    DeleteRow(index) {
        if (this.dynamicAddRow.length == 1) {
            this.toastr.error("Can't delete the row when there is only one row");
            return false;
        }
        else {
            this.dynamicAddRow.splice(index, 1);
            return true;
        }
    }

    IsAlphaNumeric(event: any) {
        var newKeyCode = event.keyCode;
        return ((newKeyCode > 64 && newKeyCode < 91) || (newKeyCode > 96 && newKeyCode < 123) || (newKeyCode == 8 || newKeyCode == 32) || (newKeyCode >= 48 && newKeyCode <= 57) || newKeyCode == 59);
    }

    onAddRowProductSelect(item: any, index: any) {
        this.productPackSize[index] = [];

        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == item.productCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.productPackSize[index].push(packSize);


            }
        }

        this.dynamicAddRow[index].ProductCode = item.productCode;
        this.dynamicAddRow[index].productName = item.productName;


    }
    onAddRowProductDeSelect(item: any, index: any) {
        this.productPackSize[index] = [];
    }

    onAddRowPackSize(item: any, index: any) {
        this.dynamicAddRow[index].PackSize = item.packSize;
    }
    onAddRowPackSizeDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].PackSize = "";
    }
    onAddRowWHLocation(item: any, index: any) {
        this.dynamicAddRow[index].WarehouseCode = item.whCode;
        this.dynamicAddRow[index].WarehouseLocation = item.whName;
    }

    ononAddRowWHLocationDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].WarehouseCode = "";
        this.dynamicAddRow[index].WarehouseLocation = "";
    }
    onDateSelectEXPDate(newValueEXPDate, index) {
        this.dynamicAddRow[index].MFGDate
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].EXPDate = nwValue;
    }
    onDateSelectMFGDate(newValueEXPDate, index) {
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].MFGDate = nwValue;
    }
    
    onDateSelectINVDate(newValueINVDate, index) {
        let nwValue = newValueINVDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].InvDate = nwValue;
    }

    onAddRowBusinessUnit(item: any, index: any) {
        this.dynamicAddRow[index].BusinessUnit = item.code;
    }
    onAddRowBusinessUnitDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].BusinessUnit = "";
    }

    onAddRowCostCenter(item: any, index: any) {
        this.dynamicAddRow[index].CostCenter = item.code;
    }
    onAddRowCostCenterDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].CostCenter = "";
    }

    ValidateDispatchToWarehouse(dynamicAddRow: any) {
        this.displayReject = 'none';
        let isValid = true;
        let isRowSelected = false;
         dynamicAddRow = dynamicAddRow.filter( x => x.IsAcknowledged == true);
        if (dynamicAddRow.length == 0) {
            isValid = false;
            this.toastr.error("Please select checkbox to acknowledge.");
            return false;
        }
        for (let i = 0; i < dynamicAddRow.length; i++) {
            if (dynamicAddRow[i].IsAcknowledged && !Boolean(dynamicAddRow[i].QtyReceived)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (dynamicAddRow[i].IsAcknowledged && !Boolean(dynamicAddRow[i].BusinessUnit)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (dynamicAddRow[i].IsAcknowledged && !Boolean(dynamicAddRow[i].CostCenter)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].IsAcknowledged)) {
                isValid = false;
                this.toastr.error("Please select checkbox to acknowledge.");
                return false;
            }
            if (dynamicAddRow[i].IsAcknowledged && !Boolean(dynamicAddRow[i].QtyDispatched)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].LR)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].OriginLocation)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].CarrierDetail)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            // if (!Boolean(dynamicAddRow[i].MFGDate)) {
            //     isValid = false;
            //     this.toastr.error("Please fill all required fields.");
            //     return false;
            // }
            if (!Boolean(dynamicAddRow[i].EXPDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].InvNo)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].InvDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            // if (!Boolean(dynamicAddRow[i].Month)) {
            //     isValid = false;
            //     this.toastr.error("Please fill all required fields.");
            //     return false;
            // }
            let mfgDate = new Date(dynamicAddRow[i].MFGDate);
            let expDate = new Date(dynamicAddRow[i].EXPDate);
            // if (expDate <= mfgDate) {
            //     isValid = false;
            //     this.toastr.error("EXP Date must be greater than MFG Date.");
            //     return false;
            // }
            if (dynamicAddRow[i].IsAcknowledged && dynamicAddRow[i].QtyReceived > dynamicAddRow[i].QtyDispatched) {
                isValid = false;
                this.toastr.error("Qty Received should not be greater than Qty Dispatched.");
                return false;
            }
        }
        if (isValid) {
            this.displayReject = 'block';
        }
    }
    closePopup(commentModal: string) {
        this.displayReject = 'none';
        this.displayEdit = 'none';
    }

    SaveDispatchToWarehouse(dynamicAddRow: any) {
        this.loader = 'block';
        this.displayReject = 'none';
        this.userId = localStorage.getItem('dsu_userId');
        var data = dynamicAddRow.filter( x => x.IsAcknowledged == true);
        let year="";
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.sdAcknowledge.SaveSDAcknowledge(data, this.userId)
            .subscribe((response) => {
                if (response.status) {
                    this.defaultView = true;
                    this.toastr.success(response.message);
                }
                else {
                    this.toastr.error(response.message);
                }
                this.loader = 'none';
            }, error => {
                this.loader = 'none';
                this.toastr.error('Some Problem Occured,Please try again later.');
            });
    }

    EditRow(stock: any) {
        //this.editStockIn = stock;
        this.editStockIn = this.DeepCopy(stock);
        this.editStockIn.productId = this.editStockIn.productCode;
        this.editStockIn.whLocation = this.editStockIn.whName;
        this.displayEdit = "block";
        let WHSelected = { whCode: this.editStockIn.whCode, whName: this.editStockIn.whName };
        



    }

    onEditRowProductSelect(item: any, index: any) {
        this.editProductPackSize = [];

        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == item.productCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.editProductPackSize.push(packSize);


            }
        }

        this.editStockIn.PackSizeSelectedList = [];

        this.editStockIn.productId = item.productCode;
        this.editStockIn.productName = item.productName;


    }

    onEditRowProductDeSelect(item: any, index: any) {
        this.editStockIn.productName = "";
        this.editStockIn.productId = "";
    }

    onEditRowPackSize(item: any, index: any) {
        this.editStockIn.packSize = item.packSize;
    }
    onEditRowPackSizeDeSelect(item: any, index: any) {
        this.editStockIn.packSize = "";
    }
    onEditRowWHLocation(item: any, index: any) {
        this.editStockIn.whCode = item.whCode;
        this.editStockIn.whLocation = item.whName;
    }

    onEditRowWHLocationDeSelect(item: any, index: any) {
        this.editStockIn.whCode = "";
        this.editStockIn.whName = "";
    }

    DeepCopy(obj: any): any {
        let clonedObject;

        if (obj === null || typeof obj !== 'object') {
            return obj;
        }
        if (obj instanceof Array) {
            clonedObject = [];
            for (let i = 0; i < obj.length; i++) {
                clonedObject[i] = this.DeepCopy(obj[i]);
            }
            return clonedObject;
        }
        if (obj instanceof Date) {
            clonedObject = new Date(obj.valueOf());
            return clonedObject;
        }
        if (obj instanceof RegExp) {
            clonedObject = RegExp(obj.source, obj.flags);
            return clonedObject;
        }
        if (obj instanceof Object) {
            clonedObject = new obj.constructor();
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    clonedObject[attr] = this.DeepCopy(obj[attr]);
                }
            }
            return clonedObject;
        }
    }

    EditDispatchToWarehouse(stockIn) {
        let isValid = true;
        if (!Boolean(stockIn.whCode)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.whLocation)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.productId)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.productName)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.packSize)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.stockReceiptDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.receivedThrough)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.receivedFrom)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.batchNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.qty)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        
        if (!Boolean(stockIn.mfgDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.docNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.expDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.invNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.invDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        let mfgDate = new Date(stockIn.mfgDate);
        let expDate = new Date(stockIn.expDate);
        if (expDate <= mfgDate) {
            isValid = false;
            this.toastr.error("EXP Date must be greater than MFG Date.");
            return false;
        }

        this.displayEdit = 'none';
        this.loader = 'block';

        if (isValid) {
            stockIn.userId = localStorage.getItem('dsu_userId');
            console.log(stockIn);
            this.sdAcknowledge.UpdateStockIn(stockIn)
                .subscribe((response) => {

                    if (response.status) {
                        this.defaultView = true;
                        this.toastr.success(response.message);
                        this.GetSDAcknowledge();
                    }
                    else {
                        this.toastr.error(response.message);
                    }
                    this.loader = 'none';
                }, error => {
                    this.loader = 'none';
                    this.toastr.error('Some Problem Occured,Please try again later.');
                });

        }
    }
}